module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/instagram-fifth-step-6d57c460cae268b69b7dc9b49c67e3fa.png";